import StockoutDetail from "./stockoutDetails.container"

export default StockoutDetail
